// Disable Dawn product image fullscreen modal on iPhone/mobile
// by unwrapping/removing modal opener triggers on mobile product pages.
(function () {
  const MOBILE_QUERY = "(max-width: 749px)";

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function isProductPage() {
    return document.documentElement.classList.contains("template-product");
  }

  function unwrap(el) {
    if (!el || !el.parentNode) return;

    const div = document.createElement("div");

    // Preserve attributes that might affect layout
    for (const attr of el.attributes) {
      if (attr && attr.name) div.setAttribute(attr.name, attr.value);
    }

    // Move children over
    while (el.firstChild) div.appendChild(el.firstChild);

    el.parentNode.replaceChild(div, el);
  }

  function disableMediaModalOnce() {
    if (!isMobile() || !isProductPage()) return;

    // Unwrap any <modal-opener> web components inside product media
    document
      .querySelectorAll("media-gallery modal-opener, .product__media-list modal-opener, modal-opener")
      .forEach(unwrap);

    // Unwrap elements that act like openers in some Dawn variants
    document
      .querySelectorAll(
        "media-gallery .product__modal-opener, .product__media-list .product__modal-opener, .product__modal-opener"
      )
      .forEach(unwrap);

    // Hide/remove magnifier icons if present
    document.querySelectorAll(".product__media-icon").forEach((icon) => icon.remove());

    // Extra guard: remove any aria-haspopup dialogs on media openers (rare)
    document
      .querySelectorAll(
        "media-gallery [aria-haspopup='dialog'], .product__media-list [aria-haspopup='dialog']"
      )
      .forEach((el) => {
        el.removeAttribute("aria-haspopup");
        el.removeAttribute("aria-controls");
      });
  }

  function runWithRetry() {
    // Run immediately and then retry a few times to catch late-rendered gallery updates
    disableMediaModalOnce();

    let tries = 0;
    const maxTries = 20; // ~2 seconds total
    const timer = setInterval(() => {
      disableMediaModalOnce();
      tries += 1;
      if (tries >= maxTries) clearInterval(timer);
    }, 100);
  }

  // Run as early as possible
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runWithRetry);
  } else {
    runWithRetry();
  }

  // Run again when Shopify re-renders sections (theme editor, ajax, etc.)
  document.addEventListener("shopify:section:load", runWithRetry);
  document.addEventListener("shopify:section:reorder", runWithRetry);
})();